




























































































declare var window: any;
import { Vue, Component, Prop } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import { CommonUserInfo } from '../../models/referrals/commonuserinfo';

@Component({
  name: 'UserForm',
  data() {
    return {
      options: [{ value: '1', text: 'USA (+1)' }],
    };
  },
})
export default class UserForm extends Vue {
  private nameRegex: RegExp = new RegExp("^[a-zA-Z-, ']+$");
  private candidatePhone: string = '';
  private noExample: boolean = true;
  @Prop({ default: new CommonUserInfo() }) userInfo;
  @Prop({ default: false }) isFriendForm;
  getChar(event): string {
    return String.fromCharCode(event.charCode ? event.charCode : event.which);
  }

  updateCandidatePhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    if(event.countryCallingCode && event.nationalNumber){
      this.userInfo.phoneNumber =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.userInfo.phoneNumberValid = event.isValid;
    }
  }

  getPastedData(event): string {
    return event.clipboardData.getData('text/plain');
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }
  get totalDropdownHeight() {
    if (!this.supportedCountries) {
      return '217px'; 
    }
    const count = this.supportedCountries.length;
    const calculated = count * 35;
    return calculated > 217 ? '217px' : `${calculated}px`;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }

  get allowedResumeFormat() {
    return vxm.configs.getGlobalConfigValue('ALLOWED_RESUME_FORMATS');
  }

  get allowedFormats() {
    const array = vxm.configs
      .getGlobalConfigValue('ALLOWED_RESUME_FORMATS')
      .split(',');
    return vxm.utility.commaAndSeparator(array);
  }
}
